LS.filters = {
	/**
	 * Reset cached data on preload
	 */
	listen() {
		const scope = this;

		$(window).on('preload', () => {
			delete scope.parsed;
		});
	},

	/**
	 * Get filter data
	 *
	 * @param {String} [key]
	 * @returns {*}
	 */
	get(key) {
		const data = (this.parsed || this.parse()).query;

		return key ?
			data[key] : $.copy(data);
	},

	/**
	 * Get filtered root
	 *
	 * @returns {*}
	 */
	root() {
		return this.parse().root;
	},

	/**
	 * Determine if the current page is a directory route
	 *
	 * @param {String} [segment]
	 * @returns {Boolean}
	 */
	isDirectory(segment) {
		return Boolean(LS.directory[
			typeof segment === 'undefined' ?
				$.routes.segments(0) : segment
		]);
	},

	/**
	 * Determine if the current page is a property route
	 *
	 * @param {String} [segment]
	 * @returns {Boolean}
	 */
	isProperty(segment) {
		segment = typeof segment === 'undefined' ?
			$.routes.segments(0) : segment;

		return Boolean(
			segment === 'properties' ||
			LS.formats[segment] ||
			LS.types[segment] ||
			LS.tags[segment]
		);
	},

	/**
	 * Determine if the current page is an entry route
	 *
	 * @param {String} [segment]
	 * @returns {Boolean}
	 */
	isEntry(segment) {
		segment = typeof segment === 'undefined' ?
			$.routes.segments(2) : segment;

		return /^\d{6,}$/.test(segment);
	},

	/**
	 * Get parsed request data
	 *
	 * @param {Array} [segments]
	 * @param {Boolean} [cached=false]
	 * @returns {Object}
	 */
	parse(segments, cached) {
		const scope = this;
		const parsed = {
			filters: {},
			structured: {}
		};

		let canonical = '';
		let query = {};
		let root = '';
		let filtered;
		let section;
		let segment;
		let skip;

		if (scope.parsed && ! cached) {
			return scope.parsed;
		}

		segments = segments || $.routes.segments();

		if (scope.isProperty(segments[0])) {
			section = 'property';

			skip = segments[0] === 'properties';

			if (skip) {
				canonical = root = '/properties';
			}
		} else if (segments[1] === 'saves') {
			section = 'property';
		} else if (segments[0] === 'collections') {
			section = 'property';

			parsed.filters = {
				collection: segments[1]
			};
		}

		if (! section && scope.isDirectory(segments[0])) {
			section = 'directory';
		}

		if (section) {
			query.page = 1;
		}

		for (let i = 0; i < segments.length; i++) {
			segment = segments[i];

			if (skip) {
				root += skip ?
					'' : '/' + segment;
				canonical += skip ?
					'' : '/' + segment;

				skip = false;

				continue;
			}

			if (
				segment === 'account' ||
				segment === 'collections'
			) {
				skip = true;

				continue;
			}

			if (segment === 'search') {
				skip = true;

				parsed.filters = {
					search: segments[i + 1]
				};

				canonical += `/${segment}/${segments[i + 1]}`;

				continue;
			}

			if (segment === 'filter') {
				filtered = skip = true;

				parsed.filters = scope.extract(segments[i + 1]);

				continue;
			}

			if (/^p\d+$/.test(segment)) {
				query.page = Number(segment.slice(1));

				if (! filtered && query.page > 1) {
					canonical += '/' + segment;
				}

				break;
			}

			if (! section) {
				canonical += '/' + segment;

				continue;
			}

			const key = LS.filters.identify(segment, section);

			if (key) {
				root += '/' + segment;
				canonical += '/' + segment;

				parsed.structured[key] = segment;

				continue;
			}

			canonical += '/' + segment;

			query.location = segment;
		}

		parsed.root = root;
		parsed.canonical = $.get('appUrl') + canonical;

		if (section) {
			parsed.section = section;
		}

		parsed.query = Object.assign(
			query, parsed.structured, parsed.filters
		);

		if (! cached) {
			scope.parsed = parsed;
		}

		return parsed;
	},

	/**
	 * Identify segment value
	 *
	 * @param {String} segment
	 * @param {String} [section='property']
	 * @returns {string}
	 */
	identify(segment, section) {
		if (section === 'directory') {
			if (LS.directory[segment]) {
				return 'type';
			}

			for (const type in LS.directory) {
				if (LS.directory[type].includes(segment)) {
					return 'specialty';
				}
			}
		} else {
			if (LS.formats[segment]) {
				return 'format';
			}

			if (LS.types[segment]) {
				return 'type';
			}

			if (LS.tags[segment]) {
				return 'tag';
			}
		}
	},

	/**
	 * Parse filter string into object
	 *
	 * @param {String} [criteria]
	 * @param {Boolean} [filter=true] - remove empty values
	 * @returns {Object}
	 */
	extract(criteria = '', filter = true) {
		if (/%(3D|25)/.test(criteria)) {
			criteria = decodeURIComponent(criteria);
		}

		const params = this.unserialize(criteria);
		const data = {};

		for (let [key, value] of Object.entries(params)) {
			const parts = key.split('[');

			if (! filter || (filter && value)) {
				if (parts.length === 1) {
					data[key] = value;

					continue;
				}

				const sub = parts[1].slice(0, -1);

				key = parts[0];

				value = LS.util.parseNumber(value);

				if (! sub) {
					data[key] = value;
				} else {
					if (! data[key]) {
						data[key] = {};
					}

					data[key][sub] = value;
				}
			}
		}

		if (Array.isArray(data.sort)) {
			data.sort = data.sort.join('+');
		}

		return data;
	},

	/**
	 * Check if extended filters are applied
	 *
	 * @param {Object} [model]
	 * @returns {Number}
	 */
	count(model) {
		const filters = model || this.get();

		let count = 0;

		Apt.filters.$private.criteria.forEach(key => {
			if (filters[key]) {
				count++;
			}
		});

		Apt.filters.$private.more.forEach(key => {
			if (filters[key]) {
				count++;
			}
		});

		[
			'price',
			'size',
			'space'
		].forEach(key => {
			if (filters[key] && (
				filters[key].min ||
				filters[key].max
			)) {
				count++;
			}
		});

		return count;
	},

	/**
	 * Merge filters into app
	 *
	 * @param {Object} data
	 */
	merge(data) {
		const scope = this;

		if (! scope.parsed) {
			scope.parse();
		}

		Object.assign(scope.parsed.query, data);
	},

	/**
	 * Compile criteria into structured endpoint
	 *
	 * @param {String} [base]
	 * @param {Object} [criteria]
	 * @param {Boolean} [paged=false]
	 * @returns {String}
	 */
	build(base, criteria, paged) {
		const scope = this;

		let segments = [base];

		if (criteria) {
			const filters = [];

			let page;

			[
				'bedrooms',
				'ppa',
				'price',
				'size',
				'space'
			].forEach(key => {
				scope.range(criteria, key);
			});

			criteria = $.unserialize(
				$.serialize(criteria)
			);

			Object.keys(scope.parse(base.split('/'), true).structured)
				.forEach(key => {
					delete criteria[key];
				});

			// noinspection PointlessBooleanExpressionJS
			if (base === null) {
				segments = [
					scope.root()
				];
			}

			if (criteria.page) {
				page = criteria.page;

				delete criteria.page;
			}

			for (let [key, value] of Object.entries(criteria)) {
				if (! value) {
					continue;
				}

				if (key === 'location') {
					segments.push(value);
				} else {
					if (Array.isArray(value)) {
						value = value.join('+');
					} else if (key.includes('[')) {
						value = LS.util.parseNumber(value);
					}

					filters.push(
						key + '=' + encodeURIComponent(value)
							.replace(/(%2[0B])+/g, '+')
					);
				}
			}

			if (base === false) {
				segments = [];
			}

			if (filters.length) {
				segments.push('filter');
				segments.push(
					filters.sort()
						.join(',')
						.replace(/\[]/g, '')
				);
			}

			if (paged !== false && page && page > 1) {
				segments.push('p' + page);
			}
		}

		let path = segments.join('/');

		if (path[0] !== '/') {
			path = '/' + path;
		}

		return path;
	},

	/**
	 * Parse filter string into query parameters
	 *
	 * @param {String} value
	 * @returns {Object}
	 */
	unserialize(value) {
		const data = $.unserialize(
			value.replace(/,/g, '&')
		);

		for (const [key, value] of Object.entries(data)) {
			if (key === 'keywords') {
				continue;
			}

			if (value.includes(' ')) {
				data[key] = value.split(' ');
			}
		}

		return data;
	},

	/**
	 * Get base page title
	 *
	 * @returns {String}
	 */
	title() {
		return document.title.replace(
			/( - [\d,]+ Properties)?( - Page \d+)? - LandSearch/i, ''
		);
	},

	/**
	 * Sort filter range
	 *
	 * @param {Object} filter
	 * @param {String} key
	 */
	range(filter, key) {
		const obj = filter[key];

		if (! obj || ! obj.min || ! obj.max) {
			return;
		}

		const values = [
			LS.util.parseNumber(obj.min),
			LS.util.parseNumber(obj.max)
		];

		filter[key].min = Math.min.apply(null, values);
		filter[key].max = Math.max.apply(null, values);
	},

	/**
	 * Get base path
	 *
	 * @param {String} [path]
	 * @returns {String}
	 */
	base(path) {
		return (path || location.pathname)
			.replace(/\/p\d+$/, '');
	}
};